/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS © 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
*/

import React from 'react'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { RaisedButton, FontIcon, Checkbox, MenuItem, CircularProgress } from 'material-ui'
import { Grid } from '@material-ui/core'
import { TextField, DatePicker, SelectField, AutoComplete } from 'generic/form'
import Card from 'generic/card/Card'
import { docSaver } from 'utils/file'

import * as actions from 'actions/Invoice'
import * as interpreterActions from 'actions/Interpreter'
import * as constants from 'constants/Header'
import * as prestationConstants from 'constants/Prestation'
import * as invoiceConstants from 'constants/Invoice'

class PaymentPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      salaryPeriod: undefined,
      allowSalary: false,
      invoicePeriod: undefined,
      allowInvoice: false,
      payingCustomerAbaCodeIncluded: undefined,
      payingCustomerAbaCodeExcluded: undefined,
      invoiceByMail: undefined,
      invoiceFile: {
        ref: this.file,
        fileType: '.xlsx',
        loading: 'loadingInvoice',
        fileName: 'prestation_invoice_import.xlsx'
      },
      salaryDates: undefined,
      provisionalSalaryDates: undefined,
      interpreter: undefined,
      salaryDate: undefined,
      provisionalSalaryDate: undefined,
      loadingSalary: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.handleSalaryDates = this.handleSalaryDates.bind(this)
    this.handleSetSalaryDateRef = this.handleSetSalaryDateRef.bind(this)
    this.handleSetInvoiceDateRef = this.handleSetInvoiceDateRef.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleDateFormatChange = this.handleDateFormatChange.bind(this)
    this.handleExportRemuneration = this.handleExportRemuneration.bind(this)
    this.handleUpdateAutocomplete = this.handleUpdateAutocomplete.bind(this)
    this.handleSalaryReportPdf = this.handleSalaryReportPdf.bind(this)
    this.handleExportProvisionalSalary = this.handleExportProvisionalSalary.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.interpreter !== this.state.interpreter &&
        this.state.interpreter) {
      const query = {
        interpreter: this.state.interpreter.uid
      }

      this.handleSalaryDates(query)
    }
  }

  async handleSalaryDates(query) {
    this.setState({
      salaryDate: undefined,
      salaryDates: undefined,
      provisionalSalaryDate: undefined,
      provisionalSalaryDates: undefined,
    })

    actions.getSalaryDates(query)
      .then((result) => {
        this.setState({
          salaryDates: result.data.objects.objects
        })
      })

    actions.getProvisionalSalaryDates(query)
      .then((result) => {
        this.setState({
          provisionalSalaryDates: result.data.objects.objects
        })
      })
  }

  handleChange(event, value) {
    const name = event.target.name
    this.setState({
      [name]: value || undefined
    })
  }

  handleSelectChange(event, index, value) {
    this.handleChange(event, value)
  }

  handleSetSalaryDateRef(field) {
    this.salaryDatePicker = field || null
  }

  handleSetInvoiceDateRef(field) {
    this.invoiceDatePicker = field || null
  }

  handleDateChange(event, value) {
    const date = moment(value).format('YYYY-MM-DD')
    this.handleChange(event, date)
  }

  handleDateFormatChange(event, value) {
    const name = event.target.name
    this.setState({
      errors: {
        ...this.state.errors,
        [name]: undefined
      }
    })

    let date = value === '' ? undefined : value

    if (date && date.length === 10) {
      const formattedDate = moment(value, 'DD.MM.YYYY')

      if (moment(formattedDate, 'YYYY-MM-DD').isValid()) {
        date = moment(formattedDate).format('YYYY-MM-DD')
      } else {
        this.setState({
          errors: {
            ...this.state.errors,
            [name]: this.props.intl.formatMessage(prestationConstants.messages.DATE_INVALID)
          }
        })

        return
      }
    }

    this.handleChange(event, date)
  }

  handleExportRemuneration(type) {
    this.setState({
      allowSalary: false
    })

    const date = moment(this.state.salaryPeriod).format('YYYY-MM-DD')

    const query = {
      api_format: 'csv',
      date_lte: date,
      csv_type: type,
    }

    this.link.href = actions.getInvoices(query, invoiceConstants.REMUNERATION)
    this.link.click()
  }

  handleExportFacturation(type) {
    this.setState({
      allowInvoice: false
    })

    const date = moment(this.state.invoicePeriod).format('YYYY-MM-DD')

    const query = {
      api_format: type,
      date_lte: date,
      paying_customer_aba_code_included: this.state.payingCustomerAbaCodeIncluded || undefined,
      paying_customer_aba_code_excluded: this.state.payingCustomerAbaCodeExcluded || undefined,
      invoice_by_mail: this.state.invoiceByMail
        ? this.state.invoiceByMail === 2
        : undefined
    }

    this.link.href = actions.getInvoices(query, invoiceConstants.FACTURATION)
    this.link.click()
  }

  handleTransformInterpreter(interpreter) {
    return {
      ...interpreter,
      display: interpreter.identities[0].first_name + ' ' + interpreter.identities[0].last_name
    }
  }

  handleUpdateAutocomplete(name, value) {
    this.setState({
      [name]: value || undefined
    })
  }

  handleSalaryReportPdf() {
    this.setState({
      loadingSalary: true
    })

    const query = {
      date: moment(this.state.salaryDate, 'MM.YYYY').format('YYYY-MM-DD'),
      interpreter: this.state.interpreter.uid
    }

    actions.getSalaryReportPdf(query)
      .then(async (result) => {
          const file = docSaver(result.data.document)
          var url = URL.createObjectURL(file)
          window.open(url,'_blank')
      })
      .finally(() => {
        this.setState({
          loadingSalary: false
        })
      })
  }

  handleExportProvisionalSalary() {
    const month = moment(this.state.provisionalSalaryDate, 'MM.YYYY')

    const query = {
      date_gte: month.clone().startOf('month').format('YYYY-MM-DD'),
      date_lt: month.clone().add(1, 'month').startOf('month').format('YYYY-MM-DD'),
      interpreter: this.state.interpreter.uid,
      api_format: 'csv',
    }

    this.link.href = actions.getInvoices(query, 3)
    this.link.click()
  }

  render () {
    const salaryStartDate = this.state.salaryPeriod &&
                            this.state.salaryPeriod &&
                            this.state.salaryPeriod.length === 10
                              ? moment(this.state.salaryPeriod).format('DD.MM.YYYY')
                              : undefined

    const invoiceStartDate = this.state.invoicePeriod &&
                             this.state.invoicePeriod &&
                             this.state.invoicePeriod.length === 10
                               ? moment(this.state.invoicePeriod).format('DD.MM.YYYY')
                               : undefined

    return (
      <Card
        title={this.props.intl.formatMessage(constants.messages.PAYMENT_IMPORT_MENU)}
        style={styles.card}
      >
        <a
          href=''
          target='_blank'
          style={{display: 'none'}}
          ref={link => { this.link = link }}
        >
        </a>

        <Grid container
          spacing={16}
          style={{paddingTop: 10}}
        >
          <Grid item md={4} xs={12} style={styles.column}>
            <h4 style={styles.title}>
              {this.props.intl.formatMessage(prestationConstants.messages.SALARY_INVOICE_EXPORT_TITLE)}
            </h4>

            <div style={styles.messageInvoice}>
              {this.props.intl.formatMessage(prestationConstants.messages.SALARY_INVOICE_EXPORT_MESSAGE)}
            </div>

            <div style={styles.datePicker.container}>
              <TextField
                name='salaryPeriod'
                value={salaryStartDate}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.SALARY_PERIOD)}
                onChange={this.handleDateFormatChange}
                mask='99.99.9999'
                errorText={this.state.errors ? this.state.errors.salaryPeriod : undefined}
                placeholderMandatory={true}
                meta={{mandatory: true}}
              />

              <DatePicker
                name='salaryPeriod'
                divStyle={{display: 'none'}}
                locale={this.props.intl.locale}
                onChange={this.handleDateChange}
                getField={this.handleSetSalaryDateRef}
              />

              <FontIcon
                onClick={() => this.salaryDatePicker.focus()}
                className='material-icons'
                style={styles.datePicker.icon}
              >
                today
              </FontIcon>
            </div>

            <Checkbox
              name='allowSalary'
              checked={this.state.allowSalary}
              label={this.props.intl.formatMessage(constants.messages.CONTROL_SALARY_DONE)}
              onCheck={this.handleChange}
              style={styles.fontText}
            />

            <RaisedButton
              label={this.props.intl.formatMessage(constants.messages.CONTROL_SALARY_FILE)}
              primary={true}
              disabled={!salaryStartDate || this.state.allowSalary}
              onClick={() => this.handleExportRemuneration(1)}
              style={styles.button}
              buttonStyle={styles.buttonStyle}
            />

            <RaisedButton
              label={this.props.intl.formatMessage(constants.messages.ABACUS_SALARY_FILE)}
              primary={true}
              disabled={!salaryStartDate || !this.state.allowSalary}
              onClick={() => this.handleExportRemuneration(2)}
              style={styles.button}
              buttonStyle={styles.buttonStyle}
            />
          </Grid>
          <Grid item md={4} xs={12} style={styles.column}>
            <h4 style={styles.title}>
              {this.props.intl.formatMessage(prestationConstants.messages.INVOICE_ORDER_EXPORT_TITLE)}
            </h4>

            <div style={styles.messageInvoice}>
              {this.props.intl.formatMessage(prestationConstants.messages.INVOICE_ORDER_EXPORT_MESSAGE)}
            </div>

            <div style={styles.datePicker.container}>
              <TextField
                name='invoicePeriod'
                value={invoiceStartDate}
                floatingLabelText={this.props.intl.formatMessage(constants.messages.SALARY_PERIOD)}
                onChange={this.handleDateFormatChange}
                mask='99.99.9999'
                errorText={this.state.errors ? this.state.errors.invoicePeriod : undefined}
                placeholderMandatory={true}
                meta={{mandatory: true}}
              />

              <DatePicker
                name='invoicePeriod'
                divStyle={{display: 'none'}}
                locale={this.props.intl.locale}
                onChange={this.handleDateChange}
                getField={this.handleSetInvoiceDateRef}
              />

              <FontIcon
                onClick={() => this.invoiceDatePicker.focus()}
                className='material-icons'
                style={styles.datePicker.icon}
              >
                today
              </FontIcon>
            </div>

            <TextField
              name='payingCustomerAbaCodeIncluded'
              value={this.state.payingCustomerAbaCodeIncluded}
              floatingLabelText={this.props.intl.formatMessage(constants.messages.PAYING_CUSTOMER_INCLUDED)}
              onChange={this.handleChange}
              errorText={
                this.state.errors
                ? this.state.errors.payingCustomerAbaCodeIncluded
                : this.props.intl.formatMessage(constants.messages.PAYING_CUSTOMER_INCLUDED_PLACEHOLDER)
              }
            />

            <TextField
              name='payingCustomerAbaCodeExcluded'
              value={this.state.payingCustomerAbaCodeExcluded}
              floatingLabelText={this.props.intl.formatMessage(constants.messages.PAYING_CUSTOMER_EXCLUDED)}
              onChange={this.handleChange}
              style={{marginTop: 10}}
              errorText={
                this.state.errors
                ? this.state.errors.payingCustomerAbaCodeIncluded
                : this.props.intl.formatMessage(constants.messages.PAYING_CUSTOMER_EXCLUDED_PLACEHOLDER)
              }
            />

            <SelectField
              name='invoiceByMail'
              value={this.state.invoiceByMail}
              onChange={this.handleSelectChange}
              floatingLabelText={this.props.intl.formatMessage(constants.messages.INVOICE_BY_EMAIL)}
              style={{
                ...styles.fontText,
                marginTop: 20
              }}
            >
              <MenuItem
                value={null}
                primaryText=""
              />

              <MenuItem
                value={1}
                primaryText={this.props.intl.formatMessage(constants.messages.INVOICE_BY_EMAIL_NO)}
              />

              <MenuItem
                value={2}
                primaryText={this.props.intl.formatMessage(constants.messages.INVOICE_BY_EMAIL_YES)}
              />
            </SelectField>

            <Checkbox
              name='allowInvoice'
              checked={this.state.allowInvoice}
              label={this.props.intl.formatMessage(constants.messages.INVOICE_CHECK_DONE)}
              onCheck={this.handleChange}
              style={{
                ...styles.fontText,
                marginTop: 20
              }}
            />

            <RaisedButton
              label={this.props.intl.formatMessage(constants.messages.CONTROL_INVOICE_FILE)}
              primary={true}
              disabled={!invoiceStartDate || this.state.allowInvoice}
              onClick={() => this.handleExportFacturation('csv')}
              style={styles.button}
              buttonStyle={styles.buttonStyle}
            />

            <RaisedButton
              label={this.props.intl.formatMessage(constants.messages.ABACUS_INVOICE_FILE)}
              primary={true}
              disabled={!invoiceStartDate || !this.state.allowInvoice}
              onClick={() => this.handleExportFacturation('xml')}
              style={styles.button}
              buttonStyle={styles.buttonStyle}
            />

            <input
              ref={(ref) => this.file = ref}
              accept='.xlsx'
              type="file"
              style={{display: 'none'}}
              onChange={(event) => this.props.handleXLSXUpload(event, this.state.invoiceFile)}
            />

            { this.props.loadingInvoice
              ? <CircularProgress
                  size={50}
                  style={styles.loader}
                />
              : <RaisedButton
                  label={this.props.intl.formatMessage(constants.messages.ABACUS_IMPORT_INVOICE_FILE)}
                  primary={true}
                  style={styles.button}
                  onClick={() => this.props.handleFileUpload(this.file)}
                  buttonStyle={styles.buttonStyle}
                />
            }

            {
              this.props.messageParams &&
              this.props.messageParams.invoiceFile
                ? <div style={{color: this.props.messageParams.invoiceFile.color, paddingTop: 10}}>
                  {this.props.messageParams.invoiceFile.message}
                </div>
                : undefined
            }
          </Grid>

          <Grid item md={4} xs={12} style={styles.column}>
            <h4 style={styles.title}>
              {this.props.intl.formatMessage(prestationConstants.messages.SALARY_REPORT_TITLE)}
            </h4>

            <div style={styles.messageInvoice}></div>

            <AutoComplete
              name='interpreter'
              textKey='display'
              valueKey='uid'
              searchKey='text'
              placeholderMandatory={true}
              meta={{mandatory: true}}
              floatingLabelText={this.props.intl.formatMessage(prestationConstants.messages.HISTORY_INTERPRETER_LABEL)}
              url={interpreterActions.SIMPLE_INTERPRETERS_URL}
              transformData={this.handleTransformInterpreter}
              updateItem={this.handleUpdateAutocomplete}
              multi={false}
            />

            <SelectField
              name='salaryDate'
              sourceKey='value'
              disabled={!this.state.interpreter}
              meta={{mandatory: true}}
              floatingLabelText={this.props.intl.formatMessage(prestationConstants.messages.SALARY_PERIOD_LABEL)}
              style={{
                ...styles.fontText,
                marginTop: 0
              }}
              onChange={this.handleSelectChange}
              value={this.state.salaryDate}
            >
              { this.state.salaryDates
                ? this.state.salaryDates.map((date, i) => (
                    <MenuItem
                      primaryText={date.value}
                      value={date.value}
                      key={date.value}
                    />
                  ))
                : <MenuItem
                    primaryText={this.props.intl.formatMessage(constants.messages.LOADING)}
                    disabled={true}
                    value=""
                  />
              }
            </SelectField>

            { this.state.loadingSalary
              ? <CircularProgress
                  size={50}
                  style={styles.loader}
                />
              : <RaisedButton
                  disabled={!this.state.interpreter || !this.state.salaryDate}
                  label={this.props.intl.formatMessage(prestationConstants.messages.SALARY_REPORT_FILE)}
                  primary={true}
                  style={styles.button}
                  buttonStyle={styles.buttonStyle}
                  onClick={this.handleSalaryReportPdf}
                />
            }

            <SelectField
              name='provisionalSalaryDate'
              sourceKey='value'
              disabled={!this.state.interpreter}
              meta={{mandatory: true}}
              floatingLabelText={this.props.intl.formatMessage(prestationConstants.messages.PROVISIONAL_SALARY_PERIOD_LABEL)}
              style={{
                ...styles.fontText,
                marginTop: 0
              }}
              onChange={this.handleSelectChange}
              value={this.state.provisionalSalaryDate}
            >
              { this.state.provisionalSalaryDates
                ? this.state.provisionalSalaryDates.map((date, i) => (
                    <MenuItem
                      primaryText={date.value}
                      value={date.value}
                      key={date.value}
                    />
                  ))
                : <MenuItem
                    primaryText={this.props.intl.formatMessage(constants.messages.LOADING)}
                    disabled={true}
                    value=""
                  />
              }
            </SelectField>

            { this.state.loadingSalary
              ? <CircularProgress
                  size={50}
                  style={styles.loader}
                />
              : <RaisedButton
                  disabled={!this.state.interpreter || !this.state.provisionalSalaryDate}
                  label={this.props.intl.formatMessage(prestationConstants.messages.PROVISIONAL_SALARY_FILE)}
                  primary={true}
                  style={styles.button}
                  buttonStyle={styles.buttonStyle}
                  onClick={this.handleExportProvisionalSalary}
                />
            }
          </Grid>
        </Grid>
      </Card>
    )
  }
}

const styles = {
  card: {
    width: '60%',
    marginLeft: '20%',
  },
  column: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  title: {
    margin: 0,
    whiteSpace: 'initial',
    color: '#0000008a',
    textAlign: 'center',
  },
  messageInvoice: {
    margin: 0,
    whiteSpace: 'initial',
    fontSize: 14,
    color: '#0000008a',
    minHeight: 36
  },
  fontText: {
    fontSize: 14,
    marginTop: 10,
    marginBottom: 10
  },
  button: {
    width: '100%',
    height: 'auto',
    overflow: 'visible',
    marginTop: 10,
  },
  buttonStyle: {
    minHeight: 36,
    padding: 0,
  },
  datePicker: {
    container: {
      position: 'relative'
    },
    icon: {
      position: 'absolute',
      right: 5,
      top: 38,
      zIndex: 10,
      cursor: 'pointer',
    },
  },
  loader: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 10,
  }
}

export default injectIntl(PaymentPage)



// WEBPACK FOOTER //
// ./src/components/staff/PaymentPage.js